@if (vm(); as vm) {
  <h5 class="tt-filter-popover-user-selector_title">{{ title | transloco }}</h5>
  <span ttInput>
    <mat-icon ttInputPrefix [icon]="'search'" [iconSize]="16" />
    <input [ngModelOptions]="{ standalone: true }" [(ngModel)]="searchTerm" />
  </span>
  <div class="tt-filter-popover-user-selector_list">
    @for (user of vm.users; track user.id) {
      <common-checkbox
        class="tt-filter-popover-user-selector_list-item"
        [checked]="user.selected"
        [id]="idPrefix + user.id"
        (checkedChange)="handleUserSelected(user)">
        {{ user | name }}
      </common-checkbox>
    }
  </div>
}
